var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppHomeNavy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5909 47.679C46.7201 48.5198 45.5395 49 44.3085 49H4.69736C2.07184 49 0 46.8905 0 44.355V22.2883V22.2724C0.00653592 20.9721 0.556782 19.7331 1.54538 18.8488L1.5495 18.8451C1.5495 18.8451 21.3551 1.1918 21.3485 1.1977C23.1292 -0.398445 25.8775 -0.398052 27.6506 1.1918L47.4563 18.8451L47.4605 18.8488C48.4491 19.7331 48.9993 20.9721 49.0058 22.2724L49.0059 22.2883V44.355C49.0059 45.599 48.5023 46.799 47.5909 47.679ZM9.39453 24.358V39.7101H39.6113V24.358L24.5029 10.8877L9.39453 24.358Z",
    fill: "#7195AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppHomeNavy);
export default __webpack_public_path__ + "static/media/app_home_navy.25a627554b724215677f5627d831482d.svg";
export { ForwardRef as ReactComponent };